/* eslint-disable max-len */
module.exports = {
  // 零碎名词
  get_secret_key: '获取密钥',
  history_session: '历史会话',
  remember_session: '记住会话',
  create_session: '创建会话',
  edit_session: '编辑会话',
  delete_session: '删除会话',
  user_type: '用户类型',
  authorized_user: '授权用户',
  root_account: '根账号',
  sub_account: '子账号',
  collaborator_id: '协作者',
  add_user: '添加用户',
  specified_domain: '指定域名',
  MAZ_configuration: '多 AZ 特性',
  MAZ_state: {
    MAZ: '已开启',
    OAZ: '已关闭',
    Off: '未开启',
    AccessDenied: '未知 (无HeadBucket权限)',
    Unknown: '未知',
  },

  // 存储桶
  bucket: [
    '存储桶', // 0
    '存储桶：{bucket}', // 1
  ],
  add_bucket: '添加桶',
  bucket_name: '存储桶名称',
  bucket_detail: '存储桶详情',
  switch_bucket: '切换存储桶',
  select_bucket: '选择存储桶',
  remote_folder: '存储桶目录',
  create_bucket: ['创建存储桶', '存储桶创建'],
  delete_bucket: ['删除存储桶', '存储桶删除'],
  edit_bucket: '编辑存储桶',
  edit_bucket_acl: '编辑存储桶 ACl 权限',
  edit_bucket_version_control: '编辑版本控制',

  // 标签
  tag: '标签',
  bucket_tag: '存储桶标签',
  tag_management: '标签管理',
  tag_key: '标签键',
  tag_value: '标签值',
  add_tags: '添加标签',
  tag_help: '标签管理使用帮助',
  delete_tag: '删除标签',
  set_tag: '设置标签',

  // 传输管理
  transmission_management: '传输管理',
  upload_domain: '上传域名',
  download_domain: '下载域名',
  cos_default_domain: 'COS默认域名',

  // 智能分层
  intelligent_tiering: '智能分层',
  intelligent_tiering_document: '智能分层文档说明',
  intelligent_tiering_access_denied: '未知 (无IntelligentTiering获取权限)',

  // 域名
  domain: '域名',
  domain_management: '域名管理',
  view_domain: '查看域名',
  default_cdn_domain: '默认加速域名',
  current_status: '当前状态',
  acceleration_domain: '加速域名',
  acceleration_region: '加速地域',
  origin_server_type: '源站类型',
  origin_server_domain_name: '源站域名',
  origin_pull_authentication: '回源鉴权',
  CDN_authentication: 'CDN 鉴权',
  default_cdn_domain_help: '默认加速域名使用帮助',
  custom_cdn_domain_help: '自定义加速域名使用帮助',
  custom_cdn_domain_help_comment: ['注：请确保添加的域名已备案并已在DNS服务商处设置好对应的CNAME。', '更多帮助请参考'],
  custom_domain_help: '自定义源站域名使用帮助',
  custom_domain_help_comment: [
    '注：该存储桶在中国大陆地区提供服务，请确保您的域名已完成备案，未备案的域名将无法作为自定义域名绑定到中国大陆的存储桶。',
    '同时，请在DNS服务商处设置好对应的CNAME记录，将请求路由至COS。',
    '更多帮助请参考',
  ],
  custom_cdn_domain: '自定义 CDN 加速域名',
  custom_domain: '自定义源站域名',
  domain_type: '源站类型',
  cname: 'CNAME',
  statu: '状态',
  speed_area_map: {
    mainland: '国内加速',
    overseas: '海外加速',
    global: '全球加速',
  },
  statu_map: {
    online: '已上线',
    offline: '未上线',
    processing: '部署中',
    rejected: '域名审核未通过，域名备案过期/被注销导致',
    ENABLED: '上线',
    DISABLED: '下线',
  },
  origin_type_map: {
    REST: '默认源站',
    cos: '默认源站',
    web: '静态网站源站',
    WEBSITE: '静态网站源站',
    ACCELERATE: '全球加速源站',
    V4_REST: '默认源站(旧)',
  },

  // 收藏路径
  access_path: ['收藏路径', '收藏路径：{path}'],
  access_path_simple: '路径',
  add_access_path_simple: '添加路径',
  add_access_path: ['添加收藏路径', '收藏路径添加'],
  edit_access_path: '编辑收藏路径',
  delete_access_path: ['删除收藏路径', '收藏路径删除'],

  show_in_local_folder: '在文件夹中显示',
  show_in_remote_folder: '在存储桶中显示',
  prefix_matching: '前缀匹配',

  region_name: '地域',
  endpoint: '请求域名',
  access_domain: '访问域名',
  bucket_domain: '存储桶域名',
  domainTypeMap: {
    defaultCos: '默认源站域名',
    defaultWebsite: '默认静态网站域名',
    defaultCdn: '默认加速域名',
    customCdn: '自定义加速域名',
    customCos: '自定义源站域名',
  },

  ETag: 'ETag',
  headers: 'Headers',

  // 对象
  object_url: '对象地址',
  copy_link_with_expires: '文件分享',
  copy_link_without_sign: '复制不带签名的对象地址',
  copy_link_with_sign: '复制带签名的临时链接，指定有效时间',
  current_file_acl: '当前文件权限',
  loading_file_acl: '正在查询文件权限',
  copy_files: {
    msg: '已复制 {count} 项',
    success_without_sign: '对象地址复制成功，链接不带签名',
    success_with_sign: '临时链接复制成功，链接 {duration} {unit}有效',
    success: '{count} 个文件/文件夹粘贴成功',
    fail: '{count} 个文件/文件夹粘贴失败',
  },
  object_count: '对象数量',

  // 权限
  permission: '权限',
  public_permission: '公共权限',
  acl: '访问权限',
  acl_simple: 'ACL权限',
  public_pemission: '公共权限',
  acl_map: {
    'public-read-write': '公有读写',
    'public-read': '公有读私有写',
    private: '私有读写',
    default: '继承权限',
    'tce-default': '默认权限',
    AccessDenied: '未知 (无ACL获取权限)',
    Unknown: '未知',
    'unknown-with-timeout': '无法获取 (请自行选择链接类型)',
  },
  user_acl: '用户权限',
  set_user_acl: '设置用户权限',
  delete_user_acl: ' 删除用户权限',
  user_acl_map: {
    FULL_CONTROL: '完全控制',
    READ: '数据读取',
    WRITE: '数据写入',
    READ_ACP: '权限读取',
    WRITE_ACP: '权限写入',
  },
  edit_acl: '修改访问权限',
  permission_management: '权限管理',
  quick_auth: '快速授权',

  // 存储类型
  storage_class: '存储类型',
  storage_class_map: {
    STANDARD: '标准存储',
    STANDARD_IA: '低频存储',
    CODE: '冷存储',
    ARCHIVE: '归档存储',
    DEEP_ARCHIVE: '深度归档存储',
    NEARLINE: '近线存储',
    INTELLIGENT_TIERING: '智能分层存储',
    MAZ_STANDARD: '标准存储 (多AZ)',
    MAZ_STANDARD_IA: '低频存储 (多AZ)',
    MAZ_COLD: '冷存储 (多AZ)',
    MAZ_INTELLIGENT_TIERING: '智能分层存储（多AZ）',
  },
  storage_class_short_map: {
    STANDARD: '标准',
    STANDARD_IA: '低频',
    COLD: '冷存储',
    ARCHIVE: '归档',
    DEEP_ARCHIVE: '深度归档',
    NEARLINE: '近线',
    INTELLIGENT_TIERING: '智能分层',
    MAZ_STANDARD: '标准(多AZ)',
    MAZ_STANDARD_IA: '低频(多AZ)',
    MAZ_COLD: '冷存储(多AZ)',
    MAZ_INTELLIGENT_TIERING: '智能分层（多AZ）',
  },
  edit_storage_class: '修改存储类型',

  // 版本控制
  version_control: '版本控制',
  versions: '历史版本',
  version_id: '版本号',
  version_map: {
    disabled: '从未启用',
    enabled: '已启用',
    suspended: '已暂停',
    accessdenied: '没权限获取',
    unknown: '未知',
  },
  deleted_flag: '删除标记',
  versioning_document: '版本控制文档说明',
  open_versioning: '开启版本控制',

  // 全球加速
  global_acceleration: '全球加速',
  global_acceleration_document: '全球加速文档说明',
  global_acceleration_domain: '全球加速域名',
  global_acceleration_status: {
    Disabled: '已关闭',
    Enabled: '已启用',
    Suspended: '已暂停',
    AccessDenied: '无权限',
    Unknown: '未知',
  },
  bucket_does_not_enable_global_acceleration: '当前存储桶未开启全球加速功能',
  learn_about_global_acceleration: '了解全球加速',
  enable_global_acceleration: '开启存储桶全球加速',

  // 分块上传
  object_path: '对象路径',
  initiator_ID: '上传发起者 ID',
  owner_ID: '对象所有者 ID',
  uploaded_size: '已上传大小',
  uploaded_part_count: '已上传分块数',
  uploadId: '上传任务 ID',
  incomplete_multipart_upload: '文件碎片',
  clear_incomplete_uploads: '清空碎片',
  multipart_upload_name: '碎片名称',
  multipart_upload_path: '碎片路径',
  loading_incomplete_upload_info: '正在获取文件碎片信息...',

  // 格式校验
  validate: {
    invalid_input: '输入内容格式校验失败，请重新输入',
    path_name_length: '访问路径长度不能超过 255 个字符',
    folder_name_length: '文件夹名称不能超过 255 个字符',
    empty_folder_name: '文件夹名称不能为空',
    empty_file_name: '文件名称不能为空',
    invalid_char_in_folder_name: '文件夹不能包含以下字符：\\ / : * ? " < > |',
    bucket_name_format_simple: '仅支持小写字母、数字和 - 的组合，不能超过50字符',
    bucket_name_length: '存储桶名称长度不能超过50个字符',
    bucket_name_char: '存储桶名称必须由数字、小写字母和 - 组成',
    bucket_name_end_with: ['存储桶名称不能以 - 开头', '存储桶名称不能以 - 结尾'],
    bucket_name_format: '存储桶名称必须由数字、小写字母和 - 组成，长度不超过50个字符',
    secret_id_empty: 'SecretId 不能为空',
    secret_key_empty: 'SecretKey 不能为空',
    region_key_empty: '地域不能为空',
    secret_key_must_start_with_AKID: 'SecretId 开头必须是 AKID',
    secret_id_format: 'SecretId 字符数不对，应该是 36 字符',
    secret_key_format: 'SecretKey 字符数不对，应该是 32 字符',
    access_path_format: '格式为 Bucket 或 Bucket/Object-prefix，如 test-1250000000 或 test-1250000000/folder/',
    need_positive_int: '填写正整数',
    need_positive_number: '请输入正数',
    support_number_and_letters: '可用数字、英文的组合',
    support_char_most: '注：最多支持 {num} 个字符',
    empty_input_content: '输入内容不能为空',
    service_domain_format: 'Service域名格式错误',
    bucket_domain_format: 'Bucket域名格式错误',
    enter_account_id: '请输入添加的账号ID',
    invalid_account_id_format: '账号ID格式填写不正确',
    cannot_be_root_via_sub: '子账号类型时账号 ID 不能为根账号',
    choose_at_least_one_permission: '请至少选择一个用户权限',
    submit_new_user: '请先提交正在新增的用户',
    enter_a_full_tag_key_and_tag_value: '请填写完整标签键和标签值',
    tag_value_length_cannot_be_greater_than_255_characters: '标签值长度不能大于 255 字符',
    tag_key_length_cannot_be_greater_than_127_characters: '标签键长度不能大于 127 字符',
    tag_keys_cannot_begin_with: "标签键不能以'项目'、'project'、'qcs:' 开头",
    repetitive_tag_keys_are_not_allowed: '标签键不允许重复',
    share_valid_time: [
      '当前账号为主账号，最长有效时间为 2 小时；使用密钥登陆子账号支持最长有效时间为1.5天',
      '子账号支持的最长有效时间为 1.5 天',
      '最长有效时间为 2 小时',
    ],
    only_allow_one_decimal: '仅支持精确到小数点后一位',
    enter_6_extract_code: '请输入 6 位提取码',
    folder_name: [
      '文件夹名称不允许为空',
      '文件夹名称不能超过255个字符',
      '文件夹名称不能以 / 开头',
      '文件夹名称不能包含连续 / ',
      '文件夹名称不允许为 .. ',
      '当前路径总长度已超过850字节',
    ],
    file_name: ['文件名称不允许为空', '', '文件名称不能以 / 开头', '文件名称不能包含连续 / '],
  },

  // 占位符
  placeholder: {
    file_prefix: '文件前缀',
    secret_id: '请输入 API 密钥 SecretID',
    secret_key: '请输入 API 密钥 SecretKey',
    add_path: '非必填，添加访问路径',
    add_remark: '非必填，添加备注名，用于账号管理',
    bucket: '格式如：test-1250000000',
    region: '格式如：ap-guangzhou',
    root_account_id: '请输入根账号ID',
    sub_account_id: '请输入子账号ID',
    collaborator_id: '请输入协作者账号ID',
    tag_key: '请输入标签键',
    tag_value: '请输入标签值',
    such_as_index_html: '例如：index.html',
    such_as_pages_error_html: '例如：pages/error.html',
    support_4xx_error_code: '支持4xx错误码',
    enter_prefix_such_as_images: '请输入前缀，如images/',
    replacement_prefix: '请输入替换跳转前缀',
    replacement_path: '请输入替换跳转路径',
  },

  // 提示
  tips: {
    whether_to_enter_access_path:
      '若当前账号拥有所有Bucket的权限，则无需输入访问路径；若当前账号只有某个存储桶或存储桶下某个目录的权限，则需要输入访问路径，格式为：Bucket或Bucket/Object-prefix，如test-1250000000',
    empty_bucket_list: '存储桶列表为空',
    create_bucket_in_console: '请创建存储桶',
    empty_file: '没有文件',
    history_session_empty: '没有历史会话记录',
    empty_history_file: '没有历史文件',
    empty_files_or_folders: '未选择文件/文件夹',
    delete_replication: '注意：当前存储桶有区域复制规则，删除操作会同步到目标存储桶。',
    share_replication: '注意：当前存储桶有区域复制规则，在分享网页中进行的上传及删除操作会同步到目标存储桶',
    same_name_file_exist: '如果同名文件已存在：',
    access_path_describe:
      '访问路径可以为【某个存储桶】或【存储桶下的某个目录】，请确保添加的路径已被授权。\n 填写的存储桶路径必须为根账号名下的存储桶，同时请确保存储桶与地域的对应关系',
    private: '私有读写: 需要进行身份验证后才能对object进行访问操作。',
    'public-read': '公有读私有写: 可对object进行匿名读操作, 写操作需要进行身份验证。',
    'public-read-write': '可对object进行匿名读操作和写操作。',
    show_thumbnail_will_generate_CI_fee:
      '当前地域显示图片缩略图功能由数据万象服务提供技术支持，开启后可能会产生万象基础图片处理费用。',
    show_thumbnail_will_generate_download_traffic:
      '当前地域显示图片缩略图功能会下载完整图片，开启后可能会产生下载流量。',
    version_control_describe:
      '开启版本控制后，所有历史版本的同名文件将会被视为独立的对象处理，独占存储空间并产生存储容量费用。',
    global_acceleration_describe: '注：启用全球加速功能，您可以更快速、稳定的传输文件至存储桶。',
    clear_history_version: ['清空历史版本', '该操作将清空当前目录下全部对象的历史版本，请慎重操作！'],

    read_bucket_ACL_permissions: '授予用户读取「存储桶访问权限」的权限',
    write_bucket_ACL_permissions: '授予用户写入「存储桶访问权限」的权限',
    read_object_ACL_permissions: '授予用户读取「对象访问权限」的权限',
    write_object_ACL_permissions: '授予用户写入「对象访问权限」的权限',

    choose_public_acl:
      '注意：公有读权限可以通过匿名身份直接读取您存储桶中的数据，存在一定的安全风险，为确保您的数据安全，不推荐此配置，建议您选择私有。',

    /**
     * empty file list different tips
     */
    // 1. 无存储桶权限
    no_access_to_bucket: '没有存储桶权限',
    concat_root_to_auth: '请联系主账号授权',
    // 2. 搜索无结果
    no_result_found: '未找到任何结果',
    try_diffrent_keyword: '尝试不同关键字',
    // 3. 文件夹为空
    empty_folder: '这个文件夹是空的',
    drag_here: '拖拽到这里即可上传',

    // 清空存储桶提示
    clear_bucket: [
      '清空存储桶将清空您桶内的所有对象，包括对象的历史版本和未完成上传碎片（',
      '清空后数据无法恢复',
      '），如您确认清空存储桶，请点击确认按钮执行。',
    ],
    object_count:
      '对象数量指存储桶中存在的对象数量。开启版本控制功能后，同名对象的历史版本都会以一个独立对象存在，会计入对象数量中。',
    specified_domain: '若已配置或添加相关域名，选择不同域名，对象地址会有相应的改变。',
    open_versions: ['如果您不希望文件被覆盖，可以 {open} 版本控制。', '开启'],
    MAZ_configuration: '开启多AZ特性后，提供同地域多个数据中心的容灾',
    tag_keys: '标签键区分大小写，支持 中文, a-z, A-Z, 0-9, +, -, _, =, /, ., :, @ 等字符',
    tag_values: '标签值区分大小写，支持 中文, a-z, A-Z, 0-9, +, -, _, =, /, ., :, @ 等字符',
    folder_name: [
      '1. 可用数字、中英文和可见字符的组合',
      '2. 用 / 分割路径，可快速创建子目录',
      '3. 不允许: 文件夹为空；连续 / ；以 / 开头',
      '4. 不允许以 .. 作为文件夹名称',
    ],
    file_name: [
      '1. 可用数字、中英文和可见字符的组合',
      '2. 用 / 分割路径，可快速创建子目录下的文件',
      '3. 不允许: 文件名为空；连续 / ；以 / 开头',
    ],

    // 上传下载限速
    single_threaded_upload_speed_limit: '总上传限速 = 单线程上传限速 x 文件并发数 x 分块并发数',
    single_threaded_download_speed_limit: '总下载限速 = 单线程下载限速 x 文件并发数 x 分块并发数',

    // 批量文件下载
    install_latest_client: '安装最新版COSBrowser',
    multi_download: [
      'COSBrowser 网页版仅支持单个文件下载。批量下载请安装 COSBrowser 客户端，同时还支持文件夹下载。若您还未安装，请单击 {0}',
      '若您已安装 COSBrowser 但多次启动失败，请自行手动打开 COSBrowser 客户端或单击{0}',
      '正在开启 COSBrowser 客户端',
    ],
    // 编辑器模式权限提示
    no_permission: '暂无权限',
    loading: '正在加载',
    list_empty: '列表为空',
  },

  // 确认提示
  confirm: {
    authorized_actions: ['授权操作确认', '确定对账号 {id} 进行授权？'],
    delete_actions: ['删除操作确认', '确定删除对账号 {id} 的授权吗？'],
    exit: '有上传或下载任务正在进行，确定要停止任务并退出吗？',
    logout: '有上传或下载任务未完成，确定要清空任务并退出登录吗？',
    rename_cover: '存在同名文件，确定覆盖吗？',
    paste_param_cover: '{type}操作会覆盖同名文件，确定{type}吗？',
    paste_cover: '粘贴操作会覆盖同名文件，确定粘贴吗？',
    delete_files_or_folders: '删除操作不能恢复，确定要删除选中的文件或文件夹吗？',
    delete_task: '删除操作不能恢复，确定删除所有任务吗？',
    delete_access_path: '确定删除访问路径 {path} 吗？删除访问路径不影响文件，可以再次添加到菜单。',
    delete_bucket: '确定删除存储桶 {bucket} 吗？请确保存储桶下所有目录和文件已删空，删除后数据不可恢复和访问。',
    delete_a_version_object: '确定删除文件 "{name}" （版本日期为 {time}） 吗？',
    delete_some_version_object:
      '确定删除文件夹 "{name}" ？删除文件夹将清空该文件夹内的所有对象，包括对象的历史版本。注意：删除后数据不可恢复和访问。',
    delete_history_version_object: '确定清空当前目录下全部文件的历史版本吗？注意：删除后数据不可恢复和访问。',
    clear_bucket: [
      '确定清空当前所选的存储桶？',
      '清空存储桶将删除您存储桶中的所有文件及文件碎片，删除后数据不可恢复和访问。',
      '请输入存储桶名称',
      '以确认执行清空操作',
    ],
    pause_intelligent_tiering: [
      '确定开启智能分层？',
      '开启存储桶的智能分层功能后，将无法关闭或暂停该功能，也无法修改其相关配置信息。',
    ],
    pause_versioning: [
      '确定暂停版本控制？',
      '暂停仍将保留历史版本的对象，新上传的对象将以null版本存在。由于跨地域复制功能依赖版本控制，若暂停则跨地域复制会同时暂停。',
      '版本控制说明',
    ],
    delete_incomplete_uploads: '确认要删除路径为 {path} 的文件碎片吗？',
    clear_incomplete_uploads: '确定要清空该存储桶下所有的文件碎片吗？',
    delete_session: ['确定要删除会话 {name} 吗？', '确定要删除会话 {name} 下的访问路径 "{path}" 吗？'],
    delete_not_exist_sub_account: '子账号 {subUin} 不存在，确认将删除子账号的授权。',
    check_remember: '取消勾选会将该条会话记录（包括访问路径）全部删除。',
    delete_tag: '确认要删除标签 {tag}',

    // 批量文件下载
    open_cosbrowser: '打开COSBrowser',
    restart_cosbrowser: '确定重启',
    login_change: '登录账号发生变更',
    switch_login: '当前页面下有其他账号请求登录，是否切换其他账号登录。',
    confirm_text: '登录其他账号',
    cancel_text: '保持当前账号',
  },

  /**
   * 统计弹窗
   */
  statistics_alert: [
    '该页面数据由云监控提供，数据可能存在延迟。该数据仅作为监控数据以供参考，准确的计费计量数据可到',
    '费用中心',
    '中查看',
  ],

  /**
   *
   * 设置页面
   *
   * */
  reset_default: '还原默认值',

  // 账号配置
  account: '账号',

  // 关于配置
  about: '关于',
  cosBrowser: 'COSBrowser - 腾讯云 COS 客户端',
  version_update: '版本更新',
  has_new_version: '新版本',
  no_new_version: '已是最新',
  check_update: '检查更新',
  update_now: '立即更新',
  update_tip: ['获取到新版本，是否立即更新？', '软件有新版本，是否立即更新？'],
  get_update: '获取更新',
  updating: '正在下载最新版本...',
  update_downloaded: '最新版本已下载完成！',
  update_restart_app: '需要重启才生效，确认重启当前软件吗？',
  client_download: '客户端下载',
  feedback: '问题反馈',
  instructions: '使用说明',
  update_log: '更新日志',
  local_log: '本地日志',
  privacy_policy: '隐私协议',
  copyright: `2017-${new Date().getFullYear()} Tencent. All Rights Reserved.`,

  // 通用配置
  general: '通用',
  language: '语言',
  chinese: '简体中文',
  english: '英语',
  service_domain: 'EndPoint/Service域名',
  service_domain_placeholder: '默认不填',
  service_domain_tip: '用作 GetService 的域名\n例子: cos.ap-beijing.myqcloud.com\n默认不填',
  bucket_domain_setting: 'Bucket域名模板',
  bucket_domain_tip:
    '用作 Bucket 请求的域名模版\n支持模板参数 {Bucket} 和 {Region}\n例子：{Bucket}.cos.{Region}.myqcloud.com\n默认不填',
  force_use_https: '使用 HTTPS',
  not_use_https: '不使用 HTTPS',
  strict_ssl: '校验 HTTPS 证书',
  ignore_ssl_error: '忽略 HTTPS 证书错误',
  auto_update: '自动更新',
  path_style: '使用后缀式',
  path_style_tip:
    '后缀式存储桶名称不再作为域名前缀，会放在请求路径里\n存储桶名称也参与签名，例如上传文件到 test-1250000000 的格式是：\nPUT https://cos.ap-beijing.myqcloud.com/test-1250000000/1.jpg\n/test-1250000000/1.jpg 会作为签名的 pathname 参与签名计算。',

  // 代理配置
  proxyType: '代理类型',
  proxy: '代理',
  no_proxy: '不使用代理，直连网络',
  system_proxy: '使用系统代理',
  custom_proxy: '使用自定义代理',

  // 上传配置
  file_parallel_limit: '文件并发数',
  chunk_parallel_limit: '分块并发数',
  chunk_retry_times: '失败重试次数',
  chunk_retry_interval: '失败重试间隔',
  upload_double_check: '上传完二次校验',
  upload_double_check_tips: '(上传完成后，获取对象信息，对比本地文件)',
  upload_add_meta_md5: '计算并添加 x-cos-meta-md5 头部 (增加耗时)',
  upload_add_meta_md5_tips: '(用于在其他渠道下载对象时，校验完成性)',
  single_threaded_upload_speed_limit: '单线程上传限速',
  // upload_add_meta_md5: '计算并添加 x-cos-meta-md5 头部 (增加耗时)', 下线该功能
  // upload_add_meta_md5_tips: '(用于在其他渠道下载对象时，校验完成性)', 下线该功能
  enter_0_for_unlimited: '输入0表示不限速',
  please_enter_an_integer_from_0_100: '请输入0-100的数字',

  // 下载配置
  change_location_tip: '更改位置',
  ask_before_download: '下载前，询问保存位置',
  download_to_location: '下载到指定位置',
  single_threaded_download_speed_limit: '单线程下载限速',

  // 【上传】对象标签
  object_tag: '对象标签',

  /**
   * oauth 登录
   * */
  oauth_login: '腾讯云账号登录',

  /**
   * 静态网站
   * */
  static_website_configuration: '静态网站配置',
  static_website: {
    endpoint: '访问节点',
    force_HTTPS: '强制 HTTPS',
    index_document: '索引文档',
    error_document: {
      name: '错误文档',
      tip: '访问出错且未匹配到重定向规则时，会返回错误文档',
    },
    redirect_rules: '重定向规则',
    http_error_code: '错误码',
    prefix_matches_with: '前缀匹配',
    replace_path: '替换路径',
    replace_prefix: '替换前缀',
    Replace_path_prefix: '替换路径前缀',
    add_rule: {
      name: '新增规则',
      tip:
        '配置重定向规则后，COS会优先检查请求是否与重定向规则匹配，当匹配到对应错误码或前缀时，会直接返回302，并将Location替换为对应路径。',
    },
    replace_content: '替换内容',
    enabled: '已开启',
    closed: '已关闭',
    learn_more: '静态网站使用帮助',
    suffix_validate: ['访问目录时匹配的索引文档', '索引文档不能为空', '索引文档不能包含斜线和问号', '请勿以 / 开头'],
    error_document_validate: ['访问出错且未匹配到重定向规则时，会返回错误文档', '错误文档不能包含问号'],
    routing_rules_error_code_validate: ['请输入错误码', '错误码仅支持4XX'],
    routing_rules_prefix_validate: ['请输入匹配的前缀', '前缀不能包含问号'],
    routing_rules_replace_validate: ['请输入替换内容', '替换内容不能包含问号'],
    enable_force_HTTPS_confirm: {
      title: '确定开启强制HTTPS吗？',
      message: '如果您设置了 CDN 域名回源静态网站源站，且使用 HTTP 协议（非加密）访问 CDN，开启此选项将会导致您的源站地址暴露给用户，用户直接访问源站而失去 CDN 加速效果。',
      ok: '确定开启',
    },
  },

  // 极智压缩
  image_slim: '图片极智压缩',
  image_slim_tips_html: '数据万象图片极智压缩开启后，图片访问时无需参数自动压缩，支持JPG、PNG、GIF格式，压缩后保留图片原文件格式。详情请看 <a href="https://cloud.tencent.com/document/product/436/49259">图片极智压缩概述</a>',
  image_slim_auto_opened: '已开启自动压缩（图片格式 {suffixList}）',
  image_slim_auto_label: '自动压缩（推荐）',
  image_slim_auto_tips: '无需添加任何额外的参数，在正常访问以下格式图片时将自动进行压缩。',
  image_slim_suffix_label: '图片格式',
  image_slim_api_opened: '开启 API 调用',
  image_slim_api_label: '通过 API 调用',
  image_slim_api_tips_html: '访问图片时，在图片链接后添加极智压缩参数 <span class="tea-text-warning">imageSlim</span>，即可访问到压缩后的图片，具体请参考<a href="https://cloud.tencent.com/document/product/460/94856" target="_blank"> 图片极智压缩接口说明 </a>。',
  image_slim_api_no_need_tips: '当前已勾选所有自动压缩的图片格式，无需通过 API 使用',
  image_slim_auto_open_and_suffix_empty_tips: '开启了自动压缩，至少要选择1种图片格式',
  shareInfo: '如需更长有效时间，可在 <a href="https://cloud.tencent.com/document/product/436/11366"> COSBrowser PC端 </a>使用密钥登陆子账号进行分享，支持最长有效时间为30天。',
};
